module.exports = "app-page-not-found .container {\n  background-color: white;\n  color: black;\n  border-radius: 20px;\n  padding: 30px;\n  margin-top: 120px; }\n  app-page-not-found .container a {\n    color: #E84E1B; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/page-not-found/page-not-found.component.scss
// module id = ./src/app/page-not-found/page-not-found.component.scss
// module chunks = main